import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async createAttachment(store, attachment) {
    return await axios({
      url: `/v1/attachments`,
      method: 'POST',
      data: { ...attachment },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async updateAttachment(store, attachment) {
    return await axios({
      url: `/v1/attachments/${attachment.id}`,
      method: 'PUT',
      data: { ...attachment },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deleteAttachment(store, attachmentID) {
    return await axios({
      url: `/v1/attachments/${attachmentID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;